import React, { useState, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import { Delete } from "@material-ui/icons";
import RangeSlider from "./SliderComponent";

export default function TextureMap({
  name,
  mapType,
  assetId,
  onRemoveMap,
  intensity,
  updateMaterialIntensity,
  getAssetUrl,
  uploadFileData,
  showIntensity = false,
}) {
  const [currentConfig, setCurrentConfig] = useState({
    intensity: intensity || 1,
    mapValue: assetId || "",
  });
  const [updatedIntensity, setIntensity] = useState(intensity || 1);

  useEffect(() => {
    setCurrentConfig({ intensity, mapValue: assetId });
  }, [intensity, assetId]);

  return (
    <div className="textureMapContainer">
      <div className="textureMapHeader">
        <div className="textureHeaderInfo">
          <div className="mapTitle">{name}</div>
          {currentConfig.mapValue && (
            <div className="mapContainer">
              <img
                src={
                  typeof currentConfig.mapValue === "string"
                    ? currentConfig.mapValue
                    : getAssetUrl(currentConfig.mapValue)
                }
                width={24}
                height={24}
                alt="preview"
              />
            </div>
          )}
        </div>
        <div className="actions">
          <Button variant="secondary" onClick={() => onRemoveMap(mapType)}>
            <Delete fontSize="small" />
          </Button>
        </div>
      </div>
      <div className="formWrapper">
        {typeof assetId === "string" && (
          <>
            {!currentConfig.mapValue && (
              <>
                <Form.Label>Upload Map File</Form.Label>
                <input
                  id="material-upload"
                  type="file"
                  accept="image/png, image/jpg, image/jpeg"
                  size="sm"
                  value=""
                  onChange={(event) => {
                    const [file] = event.target.files;
                    uploadFileData(file);
                  }}
                />
                <Form.Label htmlFor="material-upload" className="upload-label">
                  Choose File
                </Form.Label>
              </>
            )}
          </>
        )}
        {currentConfig.mapValue && showIntensity && (
          <>
            <Form.Label>Intensity</Form.Label>
            <RangeSlider
              onSliderChange={(sliderValue) => {
                setIntensity(sliderValue);
              }}
              onAfterChange={(sliderValue) => {
                setIntensity(sliderValue);
                updateMaterialIntensity(`${mapType}Intensity`, sliderValue);
              }}
              value={updatedIntensity}
            />
          </>
        )}
      </div>
    </div>
  );
}
